import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSecondHeader } from './../../contexts/SecondHeaderContext';
import UnitCard from './UnitCard/UnitCard.jsx';
import './UnitsPage.css'; // Updated CSS file name to UnitsPage.css
import { getUnitActivationsTodayCount, getLatestUse, getRecordsFromDisplayUnit, getActivationsTodayFromRecords, getLatestUseFromRecords } from './../../hooks/unitDataHooks';

function UnitsPage() {
    const { locationId } = useParams(); // Gets the locationId from the URL
    const { getLocationData, getUnitsData, currentLocation, resetCurrentUnit } = useSecondHeader();
    const [units, setUnits] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (locationId && units.length === 0) {
            getLocationData(locationId);
        }
        resetCurrentUnit(); // Reset the current unit when loading this page

    }, [locationId]);

    useEffect(() => {
        const subscription = async () => {
            if (currentLocation) {
                let tempUnits = [];
                
                // Check if display_units exists, otherwise fallback to units
                if (currentLocation.display_units && Array.isArray(currentLocation.display_units)) {
                    tempUnits = currentLocation.display_units.map((displayUnit, originalIndex) => {
                        // Preserve original index for navigation
                        return { ...displayUnit, _originalIndex: originalIndex };
                    });
                    
                    // For each display_unit, fetch records from unit_ranges
                    for (var i = 0; i < tempUnits.length; i++) {
                        const displayUnit = tempUnits[i];
                        const records = await getRecordsFromDisplayUnit(displayUnit);
                        
                        // Calculate activations and latest use from the combined records
                        var unitNewValue = { ...displayUnit };
                        unitNewValue.activations = getActivationsTodayFromRecords(records);
                        unitNewValue.latest_use = getLatestUseFromRecords(records);
                        
                        tempUnits[i] = unitNewValue;
                    }
                } else if (currentLocation.units) {
                    // Fallback to old behavior: fetch units by IDs
                    tempUnits = await getUnitsData(currentLocation.units);
                tempUnits = tempUnits.sort((a, b) => {
                    const aName = a.display_name || '';
                    const bName = b.display_name || '';
                    return bName.localeCompare(aName);
                });

                for (var i = 0; i < tempUnits.length; i++) {
                    const unit = tempUnits[i]
                    const path = `/units/${unit.unit_id}/inference-records`;
                    ////console.log("unitNewValue", unit)
                    var unitNewValue = { ...unit};
                    unitNewValue.activations = await getUnitActivationsTodayCount(path);
                    unitNewValue.latest_use = await getLatestUse(path);
    
                    tempUnits[i] = unitNewValue;
                    }
                }

                tempUnits = tempUnits.sort((a, b) => {
                    const aName = a.display_name || '';
                    const bName = b.display_name || '';
                    return bName.localeCompare(aName);
                });
                setUnits(tempUnits.reverse());
                setLoaded(true);
            }
        };

        subscription();

        
    }, [currentLocation]);

    return (
    	<div className = "UnitsPage">
	        <div className="grid-wrapper">
	            {units.length > 0 ? (
	                units.map((unit, index) => {
                        // Determine if this is a display_unit or legacy unit
                        const isDisplayUnit = currentLocation?.display_units && Array.isArray(currentLocation.display_units);
                        const unitId = unit.unit_id || (unit.unit_ranges?.[0]?.unit_id);
                        // Use original index from display_units array, not the sorted index
                        const displayUnitIndex = isDisplayUnit && unit._originalIndex !== undefined 
                            ? unit._originalIndex 
                            : (isDisplayUnit ? index : null);
                        
                        return (
	                    <UnitCard 
                                key={unitId || index} 
                                display_unit={isDisplayUnit ? unit : null}
                                unit={isDisplayUnit ? null : unit}
                                displayUnitIndex={displayUnitIndex}
                        />
                        );
                    })
	            ) : (
	                loaded && <h3 style={{ textAlign: 'center' }}>Der er ingen enheder på denne lokation</h3>
	            )}
	        </div>
        </div>
    );
}

export default UnitsPage;
